"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Raven = require("raven-js");
var config_1 = require("./config");
// tslint:disable-next-line:no-any
var wnd = window;
// tslint:disable-next-line:no-any
var globalProject = function () { return Raven._globalProject; };
// tslint:disable-next-line:no-any
var makeRequest = function (options) { return Raven._makeRequest(options); };
// tslint:disable-next-line:no-any
var parseDSN = function (str) { return Raven._parseDSN(str); };
var noop = function () { return void 0; };
var isValidConfiguration = function (configuration, options, cb) {
    // tslint:disable-next-line:no-any
    var validErrors = [];
    options.data.exception.values.forEach(function (error) {
        var frames = error.stacktrace.frames;
        for (var i = frames.length - 1; i >= 0; i--) {
            var frame = frames[i];
            if (configuration.matchUrl(frame.filename)) {
                validErrors.push(error);
                return;
            }
        }
    });
    if (validErrors.length > 0) {
        var dsn = parseDSN(configuration.dsn);
        cb(Object.assign({}, options, {
            url: options.url.replace(globalProject(), dsn.path.slice(1)),
            auth: Object.assign({}, options.auth, {
                sentry_key: dsn.user,
            }),
            onSuccess: noop,
            onFailure: noop,
            data: Object.assign({}, options.data, {
                release: configuration.release || options.data.release,
                environment: configuration.environment || options.data.environment,
                logger: configuration.logger || options.data.logger,
                server_name: configuration.serverName || options.data.server_name,
                tags: Object.assign({}, options.data.tags, configuration.tags),
                extra: Object.assign({}, options.data.extra, configuration.extra),
                user: Object.assign({}, options.data.user, configuration.user),
                exception: Object.assign({}, options.data.exception, {
                    values: validErrors,
                }),
            }),
        }));
    }
};
function initCianSentry() {
    if (wnd.Raven) {
        return;
    }
    wnd.Raven = Raven;
    wnd.Raven.configurations = [];
    wnd.Raven.config(config_1.defaultDsn, {
        ignoreUrls: config_1.ignoreUrls,
        ignoreErrors: config_1.ignoreErrors,
        shouldSendCallback: function (data) {
            return !data.exception.values
                .some(function (error) { return error.stacktrace.frames.some(function (frame) { return config_1.ignoreUrls.some(function (pattern) { return pattern.test(frame.filename); }); }); });
        },
    }).install();
    wnd.Raven.setTransport(function (options) {
        var configFound = false;
        wnd.Raven.configurations.forEach(function (configuration) {
            isValidConfiguration(configuration, options, function (newOptions) {
                configFound = true;
                makeRequest(newOptions);
            });
        });
        if (!configFound) {
            makeRequest(options);
        }
    });
}
exports.default = initCianSentry;
//# sourceMappingURL=init.js.map


//////////////////
// WEBPACK FOOTER
// ./lib/init.js
// module id = 1
// module chunks = 0